export enum EdiMessageProcessingStatus {
	Imported = 0,
	Deserialized = 10,
	Processed = 20,
	Unsent = 30,
	Sent = 40,
	SendingFailed = 50,
}